import React from 'react';
import { motion } from 'framer-motion';
export function ProblemSection() {
  return <section id="problem" className="pt-10 relative" data-id="element-123">
      <motion.div initial={{
      opacity: 0,
      y: 20
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true
    }} data-id="element-124">
        <div className="mb-8 relative" data-id="element-125">
          <h2 className="text-5xl md:text-6xl font-bold mb-3 tracking-tight" data-id="element-126">
            THE PROBLEM
          </h2>
          <div className="flex gap-2" data-id="element-127">
            {['#FF0000', '#FF8800', '#FFDD00'].map((color, i) => <div key={i} className="h-2 w-20" style={{
            backgroundColor: color
          }} data-id="element-128" />)}
          </div>
        </div>

        <div className="space-y-6" data-id="element-129">
          {[{
          title: "CREATORS CAN'T MONETIZE ETHICALLY",
          desc: "Most creators don't know how to monetise because all the options are tied to unethical social media companies and biased algorithms. Creators shouldn't have to sell their souls to Amazon link farms to make a living.",
          color: '#FF0000'
        }, {
          title: 'BILLIONAIRES CONTROL LEARNING',
          desc: 'Billionaires control everything we do online - from the social media algorithms that govern our lives to the media we consume.',
          color: '#FF8800'
        }, {
          title: 'ALGORITHMS ARE ALREADY CAUSING IRL HARM',
          desc: "The same social algorithms are telling us to be better, do more, look and talk a certain way without acknowledging the rising cost of living or the wars and violence they're supporting and earning money off of.",
          color: '#FFDD00'
        }, {
          title: 'BIG TECH IS ACTIVELY WAR-PROFITEERING',
          desc: 'The world is chaotic, and yet here we are trying to survive the day while watching wars and genocide in real time, with no off button.',
          color: '#00DD00'
        }].map((item, i) => <motion.div key={i} className="border-4 border-black bg-white overflow-hidden" initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.1
        }} data-id="element-130">
              <div className="p-3" style={{
            backgroundColor: item.color
          }} data-id="element-131">
                <h3 className="text-lg font-bold" data-id="element-132">{item.title}</h3>
              </div>
              <div className="p-5" data-id="element-133">
                <p className="text-base leading-relaxed" data-id="element-134">{item.desc}</p>
              </div>
            </motion.div>)}
        </div>
      </motion.div>
    </section>;
}